<mnc-document-shared-document-upload-emitter
  [documentTypes]="documentTypes"
  [filesAcceptableExtensions]="filesAcceptableExtensions"
  [filesUploadedlimit]="filesUploadedlimit"
  [maxFileNameSize]="maxFileNameSize"
  [maxFileSize]="maxFileSize"
  [multiple]="multiple"
  (errorDetected)="errorDetectedHandler($event)"
  (uploadedFilesChanges)="uploadedFilesChangesHandler($event)"
/>

